var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEmail, IsString, IsUUID } from 'class-validator';
export class KeycloakUserRegisterDto {
    keycloakUserId;
    firstName;
    lastName;
    email;
    /**
     * Role as defined in Keycloak, needs to be mapped to internal Role enum
     * e.g. 'THERAME_DOCTOR', 'THERAME_PATIENT', etc.
     */
    role;
    registrationLink;
    salutation;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "keycloakUserId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "lastName", void 0);
__decorate([
    IsEmail(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "email", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "role", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "registrationLink", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], KeycloakUserRegisterDto.prototype, "salutation", void 0);
//# sourceMappingURL=keycloak-user-register.dto.js.map